// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".form-selected-subject-case .title-border {\n  border: 1px solid #366baf !important;\n}\n.form-selected-subject-case .edCardId-display {\n  font-size: 14px;\n}\n.form-selected-subject-case .edCardId-display .label {\n  color: grey;\n}", ""]);
// Exports
module.exports = exports;
